import { getTypedObjectKeys } from "@mcwd/typescript-type-guards";
import { MarketoUserInputMetaObject, type MarketoUserInputMeta } from "../../types/definitions/inputs/marketo-input-meta.js";

// Get all of the names of marketo user inputs.
type EclipseUserInputNames = MarketoUserInputMeta["name"] | "eclipse_Entity" | "eclipse_NonBusinessEmail";

const EclipseUserInputNames =
  getTypedObjectKeys(MarketoUserInputMetaObject)
  .map(k => MarketoUserInputMetaObject[k].name) satisfies EclipseUserInputNames[];

type getErrorName<TName extends string> =`${TName}_Error`;

type EclipseErrorKey = getErrorName<EclipseUserInputNames>;
const EclipseErrorKey = EclipseUserInputNames.map(x => `${x}_Error`) as EclipseErrorKey[];

export const FormValidationKeys = [...EclipseErrorKey] as const;

export type FormValidationKeys = (typeof FormValidationKeys)[number];

export type FormValidationTranslationsObject = {
  readonly [Key in FormValidationKeys]: string;
}; 